<template>
  <div>
    <show-all-nfc-list v-model="showFreeList" @select="selectFreeImages" />

    <v-scroll-x-transition mode="out-in">
      <v-row v-if="step === 1" key="address" no-gutters>
        <!--        <v-col class="pa-2" cols="12">-->
        <!--          <v-row justify="center" no-gutters>-->
        <!--            <v-col v-for="(item, i) in packs" :key="i" class="pa-2" cols="2" lg="2" md="3" sm="4">-->
        <!--              <v-card :class="{'fit-pack': matchedPack == item.count}" :elevation="item.fit ? 5 : 0"-->
        <!--                      :outlined="!item.fit"-->
        <!--                      :style="item.fit ? 'transform: scale(1.1)' : ''"-->
        <!--                      class="d-flex flex-column align-center rounded-lg text-center fill-height" max-width="200"-->
        <!--                      @click="clickOnPack(item.count)">-->
        <!--                <v-card-title class="pb-1" style="word-break: break-word">-->
        <!--                  <span class="font-size-sm me-1">تعداد</span>-->
        <!--                  {{ price(item.count) }}-->
        <!--                  <span class="font-size-sm ms-1">عددی</span>-->
        <!--                </v-card-title>-->
        <!--                <v-divider class="mt-0 flex" style="width: calc(100% - 16px)"/>-->

        <!--                <v-spacer/>-->
        <!--                <v-card-subtitle-->
        <!--                  class="grey&#45;&#45;text text-decoration-line-through justify-center d-flex align-center pb-1">-->
        <!--                  {{ price(4_000_000 * item.count) }}-->
        <!--                  <span class="ms-1" style="font-size: xx-small">ریال</span>-->
        <!--                </v-card-subtitle>-->

        <!--                <v-card-subtitle-->
        <!--                  :class="{'success&#45;&#45;text': item.fit}"-->
        <!--                  class="d-flex align-center pt-0 justify-center black&#45;&#45;text">-->
        <!--                  {{ price((1_950_000 * item.count) - Math.floor((1_950_000 * item.count) * item.discount) / 100) }}-->
        <!--                  <span class="ms-1 grey&#45;&#45;text" style="font-size: xx-small">ریال</span>-->
        <!--                </v-card-subtitle>-->
        <!--              </v-card>-->
        <!--            </v-col>-->
        <!--          </v-row>-->
        <!--        </v-col>-->

        <v-col
          v-for="(item, i) in data.orders"
          :key="i"
          class="pa-2 mt-2"
          cols="12"
        >
          <v-card class="rounded-lg" outlined>
            <v-card-title>
              {{ $t("select_quantity") }}
              <v-spacer />
              <v-btn
                v-if="data.orders?.length > 1"
                icon
                @click="data.orders.splice(i, 1)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider class="mx-4 mt-0" />

            <v-row no-gutters>
              <v-col class="pa-2" cols="12" md="7">
                <v-text-field
                  v-model.number="item.quantity"
                  :min="1"
                  class="rounded-lg"
                  clearable
                  dense
                  type="number"
                  hide-details
                  :label="$t('count')"
                  @input="validateQuantity(item)"
                  outlined
                />
              </v-col>

              <v-col class="pa-2" cols="12">
                <v-tabs v-model="item.from" grow>
                  <v-tab>{{ $t("ready_samples") }}</v-tab>
                  <v-tab>{{ $t("upload_custom_design") }}</v-tab>

                  <v-tab-item>
                    <v-card-actions>
                      <v-btn
                        class="rounded-lg"
                        color="green"
                        outlined
                        @click="
                          () => {
                            showFreeList = true;
                            tempOrderImg = i;
                          }
                        "
                      >
                        <v-icon left>mdi-image</v-icon>
                        {{ $t("select_ready_card_image") }}
                      </v-btn>
                    </v-card-actions>

                    <v-row no-gutters>
                      <v-col v-show="!!item.front_image" cols="12" md="6">
                        <v-card-title>{{
                          $t("select_card_front_image")
                        }}</v-card-title>
                        <v-img
                          :src="item.front_image"
                          contain
                          max-height="200"
                        />
                      </v-col>

                      <v-col v-show="!!item.back_image" cols="12" md="6">
                        <v-card-title>{{
                          $t("select_card_back_image")
                        }}</v-card-title>
                        <v-img
                          :src="item.back_image"
                          contain
                          max-height="200"
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item>
                    <v-row no-gutters>
                      <v-col class="pa-2" cols="12" md="6">
                        <v-card-title class="pb-0">{{
                          $t("select_card_front_image")
                        }}</v-card-title>
                        <pic-selector
                          :edit-img="false"
                          :edit-name="false"
                          :field.sync="item.front_image"
                          :default-cat-name="$t('nfc_card_image')"
                          one-pic
                          single
                        />
                      </v-col>

                      <v-col class="pa-2" cols="12" md="6">
                        <v-card-title class="pb-0">{{
                          $t("select_card_back_image")
                        }}</v-card-title>
                        <pic-selector
                          :edit-img="false"
                          :edit-name="false"
                          :field.sync="item.back_image"
                          :default-cat-name="$t('nfc_card_image')"
                          one-pic
                          single
                        />
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <!-- <v-col class="pa-4" cols="12">
          <v-btn
            :disabled="!addMore"
            block
            class="btn-accept ma-0"
            depressed
            @click="addNewCount"
          >
            <v-icon left>mdi-plus</v-icon>
            {{ $t("add_quantity") }}
          </v-btn>
        </v-col> -->
      </v-row>

      <v-card
        v-else-if="step === 2"
        key="address"
        class="pa-2 rounded-lg mb-4"
        outlined
      >
        <v-card-title>
          <v-col class="py-0 px-4" cols="12">
            <v-radio-group v-model="radioGroup">
              <v-radio value="deliverComp">
                <template v-slot:label>
                  <v-icon left color="primary">mdi-office-building</v-icon>
                  {{ $t("delivery_at_company") }}
                </template>
              </v-radio>
              <v-radio value="deliverPost">
                <template v-slot:label>
                  <v-icon left color="primary">mdi-email</v-icon>
                  {{ $t("delivery_by_post") }}
                  <v-card-subtitle class="shipping-info" style="color: warning">
                    <v-icon left small color="warning">mdi-wallet</v-icon>
                    {{ $t("post_cost_and_tax_warning") }}
                  </v-card-subtitle>
                </template>
              </v-radio>

              <v-row v-if="radioGroup === 'deliverPost'">
                <v-col cols="12">
                  <v-card-title
                    style="width: 100%"
                    class="ma-4 pa-2 rounded-lg"
                    outlined
                  >
                    {{ $t("shipping_info") }}
                  </v-card-title>
                  <v-divider class="mx-4 mt-0" />
                  <user-address-picker v-model="data" />
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-card-title>
      </v-card>
    </v-scroll-x-transition>

    <v-fade-transition>
      <v-card
        v-if="!!computedPrice.count && computedPrice.count > 0"
        class="rounded-lg"
        outlined
      >
        <div class="px-4 pt-4 d-flex align-center">
          {{ $t("total_price") }}:
          <span class="mx-1 grey--text"
            >({{ use_lang(computedPrice.count) }})</span
          >
          <v-spacer />
          <b
            v-if="computedPrice.count > 5"
            class="red--text text-decoration-line-through"
            >{{ use_lang(computedPrice.price) }}</b
          >
          <b v-else class="red--text">{{
            use_lang(computedPrice.afterDiscount)
          }}</b>
          <span class="red--text ms-1">{{ $t("rial") }}</span>
        </div>
        <v-divider v-if="computedPrice.count > 5" class="mb-0 mx-4" />
        <div
          v-if="computedPrice.count > 5"
          class="px-4 pt-4 d-flex align-center"
        >
          {{ $t("price_with_discount") }}:
          <span class="mx-1 grey--text"
            >({{ use_lang(computedPrice.count) }})</span
          >
          <v-spacer />
          <b>{{ use_lang(computedPrice.afterDiscount) }}</b>
          <span class="grey--text ms-1">{{ $t("rial") }}</span>
        </div>
        <v-divider class="mb-0 mx-4" />

        <div class="px-4 pt-4 d-flex align-center">
          {{ $t("shipping_cost_order") }}:
          <v-spacer />
          <b>{{ use_lang(computedPrice.shipping_price) }}</b>
          <span class="grey--text ms-1">{{ $t("rial") }}</span>
        </div>
        <v-divider v-if="computedPrice.count > 5" class="mb-0 mx-4" />

        <div
          v-if="computedPrice.count > 5"
          class="px-4 pt-4 d-flex align-center green--text"
        >
          {{ $t("your_profit_from_purchase") }}:
          <v-spacer />
          <!-- <span class="me-1 grey--text"
            >({{ computedPrice.discount }}% {{ $t('discount') }})</span
          > -->
          <b>{{ use_lang(computedPrice.profit) }}</b>
          <span class="grey--text ms-1">{{ $t("rial") }}</span>
        </div>

        <div class="px-4 mt-4">
          <v-alert border="left" class="white--text" color="red" dense>
            {{ $t("ten_percent_tax_will_be_added") }}
          </v-alert>
        </div>

        <div class="px-4 d-flex align-center">
          {{ $t("payable_amount") }}:
          <v-spacer />
          <b>{{ use_lang(computedPrice.amount) }}</b>
          <span class="grey--text ms-1">{{ $t("rial") }}</span>
        </div>

        <v-card-actions class="mt-4" style="gap: 8px">
          <v-btn
            v-if="step > 1"
            class="rounded-lg"
            color="red"
            min-width="110"
            outlined
            @click="step--"
          >
            <v-icon left>mdi-arrow-right</v-icon>
            {{ $t("back") }}
          </v-btn>

          <v-btn
            :disabled="radioGroup === 'deliverPost' && !canSubmit"
            :loading="loading"
            :outlined="step < 2"
            class="rounded-lg flex"
            color="success"
            depressed
            @click="moveStep"
          >
            {{ step < 2 ? $t("continue") : $t("continue_shopping") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-fade-transition>
  </div>
</template>

<script>
import PicSelector from "@/view/components/UploadCenter/picSelector.vue";
import UserAddressPicker from "@/view/components/pickers/userAddressPicker.vue";
import ShowAllNfcList from "@/view/pages/list/components/nfcList/showAllNfcList.vue";

export default {
  name: "specialNfcOrder",

  components: { ShowAllNfcList, UserAddressPicker, PicSelector },

  props: {
    value: Object,
    qrId: Number,
  },

  data: () => ({
    showFreeList: false,
    step: 1,
    packs: [
      { count: 5, discount: 10 },
      { count: 10, discount: 20 },
      { count: 30, discount: 25 },
      { count: 50, discount: 30 },
      { count: 75, discount: 35 },
      { count: 100, discount: 40 },
      { count: 200, discount: 42 },
      { count: 300, discount: 44 },
      { count: 400, discount: 46 },
      { count: 500, discount: 50 },
      { count: 600, discount: 52 },
      { count: 700, discount: 54 },
      { count: 800, discount: 56 },
      { count: 900, discount: 58 },
      { count: 1000, discount: 60 },
      { count: 2000, discount: 64 },
      { count: 3000, discount: 68 },
      { count: 4000, discount: 70 },
      { count: 5000, discount: 74 },
      { count: 6000, discount: 76 },
      { count: 7000, discount: 78 },
      { count: 8000, discount: 80 },
      { count: 9000, discount: 82 },
      { count: 10000, discount: 90 },
    ],
    radioGroup: "deliverPost",
    tempOrderImg: 0,
    data: {
      province: "",
      city: "",
      postal_code: "",
      address: "",
      orders: [
        {
          from: 0,
          front_image: null,
          back_image: null,
          quantity: 1,
        },
      ],
      qr_id: "",
      type: "",
    },
    loading: false,
  }),

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedPrice() {
      const findRange = (number) => {
        // If the number is less than the first element's count
        if (number < this.packs[0].count) {
          return 0;
        }

        // If the number is greater than or equal to the last element's count
        if (number >= this.packs[this.packs.length - 1].count) {
          return this.packs[this.packs.length - 1].discount;
        }

        // Use binary search for efficient range finding
        let left = 0;
        let right = this.packs.length - 1;

        while (left <= right) {
          const mid = Math.floor((left + right) / 2);
          if (
            number >= this.packs[mid].count &&
            number < this.packs[mid + 1].count
          ) {
            return this.packs[mid].discount;
          } else if (number < this.packs[mid].count) {
            right = mid - 1;
          } else {
            left = mid + 1;
          }
        }
      };
      const count = this.data.orders.reduce((sum, item) => {
        return sum + (Number(item.quantity) || 0);
      }, 0);
      // let count = 0;
      // this.data.orders?.forEach((item) => {
      //   count += Number(item.quantity);
      // });
      let discount = findRange(Number(count));
      let amount = 4000000 * Number(count);
      let price = 6000000 * Number(count);
      let afterDiscount =
        discount > 0 ? amount - Math.floor((amount * discount) / 100) : amount;
      let profit = price - afterDiscount;
      let sp = this.radioGroup === "deliverPost" ? 790000 : 0;

      return {
        price: this.price(price),
        shipping_price: this.price(sp),
        profit: this.price(profit),
        afterDiscount: this.price(afterDiscount),
        total: this.price(afterDiscount * 1.1),
        amount: this.price(Math.ceil(afterDiscount * 1.1 + sp)),
        discount,
        count,
      };
    },
    // matchedPack() {
    //   const between = (x, min, max) => {
    //     return !!max
    //       ? x >= min && x < max
    //       : x >= min
    //   }
    //
    //   return this.packs
    //     .find((item, i) => between(this.computedPrice.count, item.count, this.packs?.[i + 1]?.count))?.count
    // },
    addMore() {
      return this.data.orders.every((item) => item.quantity);
    },
    canSubmit() {
      const step1Valid = this.data.orders.every(
        (item) => item.quantity >= 1 && !!item.front_image && !!item.back_image,
      );
      const step2Valid =
        step1Valid &&
        !!this.data.province &&
        !!this.data.city &&
        !!this.data.postal_code &&
        !!this.data.address;
      console.log(this.data, "data");
      return this.step === 1 ? step1Valid : step2Valid;
    },
  },

  methods: {
    validateQuantity(item) {
      if (!item.quantity || item.quantity < 1) {
        this.$set(item, "quantity", 1);
      }
    },
    // clickOnPack(count) {
    //   this.data.orders = [{
    //     front_image: '',
    //     back_image: '',
    //     quantity: count
    //   }]
    //   this.$forceUpdate()
    // },
    addNewCount() {
      this.data.orders.push({
        from: 0,
        front_image: null,
        back_image: null,
        quantity: 1,
      });
    },
    moveStep() {
      if (this.step > 1) this.addNewOrder();
      this.step++;
    },
    selectFreeImages({ front_image, back_image }) {
      const order = this.data.orders[this.tempOrderImg];
      this.$set(order, "front_image", front_image);
      this.$set(order, "back_image", back_image);
      // this.data.orders[this.tempOrderImg] = {
      //   ...this.data.orders[this.tempOrderImg],
      //   front_image,
      //   back_image,
      // };
      this.$forceUpdate();
    },
    addNewOrder() {
      this.loading = true;

      const data = {
        ...this.data,
        orders: this.data.orders.map((item) => ({
          quantity: Number(item.quantity) || 1,
          front_image: item.front_image,
          back_image: item.back_image,
          method_delivary:
            this.radioGroup === "deliverPost" ? "post" : "compony",
        })),
        qr_id: this.qrId,
      };

      this.$api
        .post("/v2/calculate-nfc", data)
        .then(({ data }) => {
          this.$toast.success(this.$t("order_registered_successfully"));
          this.$emit("close");
        })
        .catch(({ response }) => {
          this.$toast.error(
            response?.data?.message || this.$t("error_registering_nfc_order"),
          );
          console.log("failed to add order: ", response);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.fit-pack {
  background-color: rgb(135 235 230 / 25%) !important;
}
</style>
